import { UserRoundCheck } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/common/PageHeader'
import { EmptyState, ErrorState } from '@/components/common/States'
import { Skeleton } from '@/components/ui/skeleton'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useAuth } from '@/lib/auth/AuthProvider'
import { AssignmentRequestList } from './components/assignment/AssignmentRequestList'
import { SPRINT_PERMS, useAssignmentRequests } from './sprintApi'

type View = 'pending_me' | 'mine' | 'all'

/** Atama talepleri: onayımı bekleyenler, talep ettiklerim ve (firma sahibi onaycısı için) tümü. */
export function AssignmentRequestsPage() {
  const { t } = useTranslation()
  const { can } = useAuth()
  const [view, setView] = useState<View>('pending_me')
  const q = useAssignmentRequests({ scope: view === 'all' ? '' : view })
  const items = q.data ?? []
  return (
    <>
      <PageHeader eyebrow={t('nav.groups.projects')} title={t('projects.assignments.pageTitle')} description={t('projects.assignments.pageSubtitle')} />
      <div className="space-y-3">
        <Tabs value={view} onValueChange={(v) => setView(v as View)}>
          <TabsList size="sm">
            <TabsTrigger value="pending_me">{t('projects.assignments.views.pending_me')}</TabsTrigger>
            <TabsTrigger value="mine">{t('projects.assignments.views.mine')}</TabsTrigger>
            {can(SPRINT_PERMS.approveOwner) ? <TabsTrigger value="all">{t('projects.assignments.views.all')}</TabsTrigger> : null}
          </TabsList>
        </Tabs>
        {q.isError ? (
          <ErrorState error={q.error} onRetry={() => void q.refetch()} />
        ) : q.isLoading ? (
          <Skeleton className="h-40 rounded-xl" />
        ) : !items.length ? (
          <EmptyState icon={UserRoundCheck} title={t('projects.assignments.empty')} />
        ) : (
          <AssignmentRequestList items={items} showTask />
        )}
      </div>
    </>
  )
}
